import API from "../../../../../app/api";

export const getSizeGuide = async () => {
    const res = await API.get(`/pages/size-guide`);

    if (res.data?.status !== 200) {
        throw new Error("Failed to fetch size guide");
    }

    return res.data.data;
};

